import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useProviderInfo } from '../hooks/useProviderInfo';
import {
  getProviderDashboardMenuSettings,
  type ProviderDashboardMenuSettings,
} from '../utils/providerDashboardMenu';

type MenuFeature = keyof ProviderDashboardMenuSettings;

type Props = {
  feature: MenuFeature;
  children: React.ReactNode;
};

/**
 * Bloque l’accès direct à une route si le menu correspondant est désactivé pour ce partenaire.
 */
const ProviderMenuFeatureRoute: React.FC<Props> = ({ feature, children }) => {
  const { data: providerInfo, isPending } = useProviderInfo();

  if (isPending && !providerInfo) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={240}>
        <CircularProgress />
      </Box>
    );
  }

  const menu = getProviderDashboardMenuSettings(providerInfo);
  if (!menu[feature]) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default ProviderMenuFeatureRoute;
